import { createFileRoute } from "@tanstack/react-router";

import { MobileRequiredScreen } from "@/modules/mobile-required/screens/MobileRequiredScreen";

export const Route = createFileRoute("/mobile-required")({
  component: MobileRequiredScreen,
});
